import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
function ImageComp({ image, id, alt }) {
  const img = getImage(image);
  
  return (
    <>
      <GatsbyImage image={img} alt={alt} id={id} />
    </>
  );
}

export { ImageComp };
